import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import axios from 'axios'
import moment from 'moment'
import * as CONSTANTS from '@/shared/constants'

window.eventBus = new Vue();
Vue.config.productionTip = false


Vue.prototype.$CONSTANTS = CONSTANTS;
Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$requiredBlur = { required: true, message: 'Campo obrigatório.', trigger: 'blur'};
Vue.prototype.$requiredChange = { required: true, message: 'Campo obrigatório.', trigger: 'change'};
Vue.prototype.$emailBlur = { type: 'email', message: 'E-mail inválido.', trigger: 'blur' };
Vue.prototype.$dataBlur = { validator: (rule, value, callback) => {

  if(!value){
      callback();
      return false;
  }
      
  if (value.length == 10 && !moment(value, 'DD/MM/YYYY').isValid()) {
      callback(new Error('Data inválida.'));
  } else {
      callback();
  }

}, trigger: 'blur' };

Vue.prototype.$registroBlur = { validator: (rule, value, callback) => {

  value = value.replace(/\.|\-/g, '');
 
  if(!value || value.length != 32){
      callback();
      return false;
  }

  let numero = '';
	let dv = '';
	let dvCalculado = '';

	dv = value.substring(30, 32);
	numero = value.substring(0, 30);

	for(let n = 1; n <= 2; n++){

		let soma = 0;
		let mult = (n == 1) ? 2 : 1;
		
		for(let i = 0; i<= numero.length -1; i++){

			if(mult > 10)            
			mult = 0
			
			soma += (mult * parseInt(numero.charAt(i)));
			mult++;
		}

		let dvTemp = soma % 11;

		if(dvTemp == 10)
		dvTemp = 1;
		
		numero = numero + dvTemp;

		dvCalculado += dvTemp.toString();

  }

  if(dv == dvCalculado){

    callback();

  }else{

    callback(new Error('Registo inválido.'));
  }
  
}, trigger: 'blur' };


Vue.prototype.$removerAcentos = ( newStringComAcento ) => {
  var string = newStringComAcento;
	var mapaAcentosHex 	= {
		a : /[\xE0-\xE6]/g,
    A : /[\xC0-\xC6]/g,
    e : /[\xE8-\xEB]/g,
    E : /[\xC8-\xCB]/g,
    i : /[\xEC-\xEF]/g,
    I : /[\xCC-\xCF]/g,
    o : /[\xF2-\xF6]/g,
    O : /[\xD2-\xD6]/g,
    u : /[\xF9-\xFC]/g,
    U : /[\xD9-\xDC]/g,
    c : /\xE7/g,
    C : /\xC7/g,
    n : /\xF1/g,
    N : /\xD1/g,
	};

	for ( var letra in mapaAcentosHex ) {
		var expressaoRegular = mapaAcentosHex[letra];
		string = string.replace( expressaoRegular, letra );
	}

	return string;
}

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import money from './shared/moneys'
Vue.use(money, {precision: 4})

import cPanel from './shared/c-panel/c-panel'
Vue.component('c-panel', cPanel);

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/pt'
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI, { size: 'small', locale });

// Vue.config.errorHandler = function (err, vm, info) {
   
//   let dados = {status: 'ABERTO', instance: 'ERRO NO FRONTEND', channel: 'production', level: '400', level_name: 'ERROR', message: err.message, context: store.state.config.userName+' '+store.state.config.slug};

//   axios.post(`${store.state.config.baseUrlApi}/api/log/store`, dados, store.getters.getHeaderAuth).then(response => {
              
//       window.eventBus.$emit('loading', false);
//       router.push('/admin/erro-500');
      
//   })
// }

Vue.filter('truncate', function(text, length, clamp){

  if(!text)
    return '-';

  clamp = clamp || '...';
  return text.length > length ? text.slice(0, length) + clamp : text;
});

axios.interceptors.response.use((response) => {
  
  if(typeof response.data.erro !== 'undefined' && (response.data.erro.cod == 800 || response.data.erro.cod == 801)){

    router.push('/not-permission');
  }

  return response;

});

import * as VueGoogleMaps from 'vue2-google-maps'

// Instala o vue2-google-maps com a chave resolvida e monta o app.
// A lib exige a chave no momento da instalação, por isso o mount espera a chave chegar.
function iniciarApp (googleMapsKey) {

  const chave = googleMapsKey || '';

  // Disponibiliza a chave para as telas de mapa checarem se podem renderizar.
  Vue.prototype.$googleMapsKey = chave;
  window.__GOOGLE_MAPS_KEY__ = chave;

  Vue.use(VueGoogleMaps, {
    load: {
      key: chave,
      libraries: ['places']
    },
    installComponents: true
  })

  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app')
}

// A chave do Google Maps é global e vem do banco (parametros_sistema) via endpoint público.
// Fallback para a variável de ambiente caso o endpoint falhe (contingência/transição).
axios.get(`${process.env.VUE_APP_BASE_URL}/api/parametro-sistema-public/google-maps-key`).then(response => {
  const chave = (response.data && response.data.google_maps_key) ? response.data.google_maps_key : (process.env.VUE_APP_GOOGLE_MAPS_KEY || '');
  iniciarApp(chave);
}).catch(() => {
  iniciarApp(process.env.VUE_APP_GOOGLE_MAPS_KEY || '');
});